module.exports = __webpack_public_path__ + "static/media/icon1.29c97981.svg";